import { formatDate } from '@angular/common';
import { InjectionToken } from '@angular/core';
declare let L: any;

import { AbstractControl, ValidatorFn } from '@angular/forms';
import { v4 as uuidv4 } from 'uuid';
import { LoadingSpinnerService } from './app/shared/services/loading-spinner.service';
// Need to review the variable of nebular and use the variable of Bpptstrap
export const DIALOG_DATA = new InjectionToken<any>('DIALOG_DATA');

// job type identities
// IDENTITY_RESPONSE = 0, _("RESPONSE")
// IDENTITY_SERVICE = 1, _("SERVICE")
// IDENTITY_STATIC_GUARD = 2, _("STATIC GUARD")
// IDENTITY_OTHERS = 3, _("OTHER")
// IDENTITY_CHECKPOINT_PATROL = 4, _("CHECKPOINT PATROL")
// IDENTITY_CASUAL_PATROL = 5, _("CASUAL PATROL")
// IDENTITY_RUNSHEET = 6, _("RUNSHEET")

// job status identities
//  IDENTITY_NORMAL = 0, _("NORMAL")
// IDENTITY_COMPLETE = 1, _("COMPLETE")
// IDENTITY_CANCELLED_BY_SUBSCRIBER = 2, _("CANCELLED BY SUBSCRIBER")
// IDENTITY_CANCELLED_BY_LC = 3, _("CANCELLED BY LC")
// IDENTITY_ONSITE = 4, _("ONSITE")
// IDENTITY_OFFSITE = 5, _("OFFSITE")
// IDENTITY_REOPEN = 6, _("RE OPEN")
// IDENTITY_DELETE = 7, _("DELETE")
// IDENTITY_IN_TRANSIT = 8, _("IN TRANSIT")
// IDENTITY_REVIEW = 9, _("REVIEW")
// IDENTITY_APPROVE = 10, _("APPROVE")
// IDENTITY_INVOICED = 11, _("INVOICED")
// IDENTITY_DO_NOT_INVOICE = 12, _("DO NOT INVOICE")
// IDENTITY_PAID = 13, _("PAID")

export const currentTheme: any = 'default';
export const alarmResponseStaleMinutes: number = 45;
export const MAX_SHIFT_DURATION: number = 18; //hours
export function getInstanceRegion() {
  return localStorage.getItem(btoa('INSTANCE_REGION_NAME')) || 'AUSTRALIA';
}
export const allowedImageFormats = ['jpeg', 'jpg', 'png', 'avif', 'webp'];

export function getRegionCurrency(symbol = false) {
  let returnValue = symbol ? '$' : 'AUD';
  switch (getInstanceRegion()) {
    case 'NEW ZEALAND':
      returnValue = symbol ? '$' : 'NZD';
  }
  return returnValue;
}
export function getPricingDescription() {
  let returnValue = 'Australian';
  switch (getInstanceRegion()) {
    case 'NEW ZEALAND':
      returnValue = 'New Zealand';
  }
  return `Pricing is inclusive of GST and in ${returnValue} Dollars`;
}

export function noWhitespaceValidator(): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const isWhitespace = (control.value || '')?.trim().length === 0;

    return isWhitespace ? { whitespace: 'value is only whitespace' } : null;
  };
}
export function getRandomInteger(min: number, max: number) {
  return Math.floor(Math.random() * (max - min + 1)) + min;
}
export const radiusRangeListGlobal: any = [100, 250, 500, 750, 1000];

export function getTimerValueDuration(startTime: any, endTime: any) {
  let diffInTime = endTime?.getTime() - startTime?.getTime();

  return getTimerValueDurationFromMilliSeconds(diffInTime);
}
function pad(num: number): string {
  return num < 10 ? `0${num}` : `${num}`;
}
export function getTimerValueDurationFromMilliSeconds(diffInTime: any) {
  if (!diffInTime) return '0';
  let seconds = Math.floor(diffInTime / 1000);
  let hours = Math.floor(seconds / 3600);
  let minutes = Math.floor((seconds % 3600) / 60);

  return `${hours}:${pad(minutes)}`;
}

export function getTimeZoneValuesWithDiff(timeZoneList: any) {
  if (!timeZoneList?.length) timeZoneList = Intl.supportedValuesOf('timeZone');
  let timeZoneListData: any = [];
  timeZoneList?.forEach((timeZone: any) => {
    const tZinfo = getTimezoneInfo(timeZone);
    if (tZinfo) timeZoneListData.push(tZinfo);
  });
  return timeZoneListData;
}
export function convertUTCStringToOffset(utcString: string) {
  const match = utcString?.match(/UTC([+-]\d{2}):(\d{2})/);

  if (!match) {
    // No match found, return the system's timezone offset
    const systemOffsetMinutes = -new Date().getTimezoneOffset();
    const isNegative = systemOffsetMinutes < 0;
    const absoluteOffset = Math.abs(systemOffsetMinutes);

    const hours = Math.floor(absoluteOffset / 60)
      .toString()
      .padStart(2, '0');
    const minutes = (absoluteOffset % 60).toString().padStart(2, '0');

    return `${isNegative ? '-' : '+'}${hours}${minutes}`;
  }

  const sign = match[1][0];
  const hours = match[1].slice(1);
  const minutes = match[2];

  return `${sign}${hours}${minutes}`;
}

export function getTimezoneInfo(timeZone: string) {
  try {
    const now = new Date();
    const options: Intl.DateTimeFormatOptions = {
      timeZone,
      hour12: true,
      hour: '2-digit',
      minute: '2-digit',
    };

    const formatter = new Intl.DateTimeFormat('en-US', {
      timeZone: timeZone,
      hour12: false,
      hour: '2-digit',
      minute: '2-digit',
      timeZoneName: 'short',
    });

    let offsetString: any = formatter
      .formatToParts(now)
      .find((part) => part.type === 'timeZoneName')?.value;
    const utcIndex = offsetString.indexOf('GMT');
    offsetString = offsetString.slice(utcIndex + 3);
    // Check if minutes part is zero
    if (offsetString.length <= 3) {
      offsetString += ':00';
    }
    const info: any = {
      localTime: now.toLocaleTimeString('en-AU', options),
      gmtOffset: `(UTC ${offsetString})`,
      value: timeZone,
    };
    return info;
  } catch (error) {
    return null;
  }
}

export function getFormattedForm(dirtyForm: any, controlsToTrim: string[]) {
  controlsToTrim.forEach((key) => {
    const control = dirtyForm.get(key);
    if (control?.value && typeof control?.value === 'string') {
      const trimmedValue = control?.value?.trim();
      control.setValue(trimmedValue, { emitEvent: false });
      control.updateValueAndValidity();
    }
  });
}

export function getFormattedDate(val?: any) {
  let date = val ? new Date(val) : new Date();
  let year = date.getFullYear();
  let month = String(date.getMonth() + 1).padStart(2, '0');
  let day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`; // YYYY-MM-DD
}
export function removeYIfYPresent(inputString: string): string {
  if (inputString?.includes('y')) {
    return inputString.replace(/y/g, '');
  }
  return inputString;
}
export function formatDateTimeStamp(
  value: any,
  format: string,
  timeZone: string,
) {
  if (!value) return '';
  const currentYear = new Date().getFullYear();
  const eventYear = new Date(value).getFullYear();

  const dateTimeFormat =
    currentYear === eventYear ? removeYIfYPresent(format) : format;

  return formatDate(value, dateTimeFormat, timeZone);
}
export function getFormattedTime(val?: any) {
  let date = val ? new Date(val) : new Date();
  return date.toTimeString().split(' ')[0].slice(0, 5); // HH:MM
}

export function getFormattedDateTime(val?: any) {
  return `${getFormattedDate(val)}T${getFormattedTime(val)}:00`;
}

export const isLargeScreen: Boolean = !(
  (window.innerWidth < 1000 && navigator.maxTouchPoints > 0) ||
  // added this to get btns in the desktop mobile vew.
  window.innerWidth < 770
);

export function getUserReadableDateTimeFormat(timestamp: any): string {
  const eventDate = timestamp ? new Date(timestamp) : new Date();
  const today = new Date();
  const yesterday = new Date();
  yesterday.setDate(today.getDate() - 1);
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  if (eventDate.toDateString() === today.toDateString()) {
    return 'Today';
  } else if (eventDate.toDateString() === yesterday.toDateString()) {
    return 'Yesterday';
  } else if (eventDate.toDateString() === tomorrow.toDateString()) {
    return 'Tomorrow';
  } else {
    return formatDateTimeStamp(eventDate, 'd MMM y', 'en_US');
  }
}

export function isLargeScreenFun(): Promise<boolean> {
  const promise = new Promise<boolean>((resolve) => {
    setTimeout(() => {
      resolve(
        !(
          (window.innerWidth < 1000 && navigator.maxTouchPoints > 0) ||
          // added this to get btns in the desktop mobile vew.
          window.innerWidth < 770
        ),
      );
    }, 500);
  });

  return promise;
}
function setTime(date: Date, time: string) {
  const [hours, minutes] = time?.split(':');
  date.setHours(parseInt(hours), parseInt(minutes), 0, 0);
}
export function getStartEndDateTime(scheduleData: any, eventDate?: any) {
  let startTime = eventDate ? new Date(eventDate) : new Date();
  let endTime = eventDate ? new Date(eventDate) : new Date();

  if (scheduleData?.repeat_type == 'once') {
    startTime = new Date(
      scheduleData?.start_day + ' ' + scheduleData?.start_time,
    );
    endTime = new Date(scheduleData?.end_day + ' ' + scheduleData?.end_time);
  } else {
    if (scheduleData?.start_time > scheduleData?.end_time) {
      endTime.setDate(endTime.getDate() + 1);
    }

    setTime(startTime, scheduleData?.start_time);
    setTime(endTime, scheduleData?.end_time);
  }

  return [startTime, endTime];
}
export function calculateTimeDifference(scheduleData: any) {
  let [startDateTime, endDateTime] = getStartEndDateTime(scheduleData);

  var timeDifference = endDateTime.getTime() - startDateTime.getTime();

  // Convert milliseconds to minutes
  var minuteDifference = timeDifference / (1000 * 60);

  return minuteDifference;
}

export function getWelfareCheckInterval(minutes: number) {
  let intervalData = [];
  if (minutes > 15) {
    intervalData.push(
      { name: 'Disabled', value: 0 },
      { name: '15 mins', value: 15 },
    );
  }
  if (minutes > 30) {
    intervalData.push({ name: '30 mins', value: 30 });
  }

  if (minutes > 60) {
    intervalData.push({
      name: '1 Hour',
      value: 60,
    });
  }
  if (minutes > 120) {
    intervalData.push({
      name: '2 Hours',
      value: 120,
    });
  }
  return [intervalData, { 5: 1, 15: 3, 30: 5, 60: 10, 120: 15 }];
}

export function getInitalDateRangeForListData(cardColumns: any = []) {
  let filteredItems = cardColumns?.filter(
    (item: any) => item?.datetimeObj == true,
  );
  let keyValue =
    filteredItems?.find((item: any) => item?.default) || filteredItems[0];
  if (keyValue?.dateRange) {
    return keyValue?.dateRange;
  } else {
    const today = new Date();
    today.setDate(new Date().getDate() - 1);
    return {
      start: today,
      end: new Date(),
    };
  }
}

export function dateRangeValueConverter(inputDate: Date, dateOnly = false) {
  return String(
    formatDateTimeStamp(
      inputDate,
      dateOnly ? 'd MMM y' : 'd MMM y HH:mm',
      'en_US',
    ),
  );
}

export const globalLocationContact = {
  individualDetails: [
    {
      nestedValue: (row: any) => {
        return row?.['user']?.['full_name'];
      },

      cardRowStyle: {
        'font-weight': 'bolder',
      },
    },
    {
      nestedValue: (row: any) => {
        return row?.['user']?.['email'];
      },

      cardRowStyle: {
        'font-size': 'small',
      },
    },
    {
      nestedValue: (row: any) => {
        return row?.['user']?.['mobile_number'];
      },
      cardRowStyle: {
        'font-size': 'small',
      },
    },
  ],
};

export const globalUserFeedbackStatusColor = {
  'COMPLETED': 'var(--bs-green)',
  'IN PROGRESS': 'var(--bs-yellow)',
  'ON HOLD': 'var(--bs-danger)',
  'N/A': 'var(--bs-green)',
  'NEW': 'var(--bs-gray-100)',
};
export const globalUserTypeColors = {
  registered: 'var(--color-success-400)',
  pending: 'var(--color-danger-400)',
};
let today = new Date();
today.setDate(today.getDate() - 1);
export const yesterday = today;

export const mapLayers = {
  'Google Hybrid': L.tileLayer(
    'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
    {
      maxZoom: 18,
      minZoom: 10,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution:
        '&copy; <a href="https://maps.google.com/help/terms_maps.html">Google Maps</a> ',
    },
  ),
  'Google Satlite': L.tileLayer(
    'https://{s}.google.com/vt/lyrs=s&x={x}&y={y}&z={z}',
    {
      maxZoom: 18,
      minZoom: 10,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
      attribution:
        '&copy; <a href="https://maps.google.com/help/terms_maps.html">Google Maps</a> ',
    },
  ),
  'Default': L.tileLayer('https://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
    maxZoom: 18,
    minZoom: 10,
    subdomains: ['mt0', 'mt1', 'mt2', 'mt3'],
    attribution:
      '&copy; <a href="https://maps.google.com/help/terms_maps.html">Google Maps</a> ',
  }),
};

// 0 = High accuracy
// 1 = Low accuracy
// 2 = IP Lookup
// 3 = Cached value

export const browserGpsInfo = {
  0: { description: 'High' },
  1: { description: 'Low' },
  2: {
    description: 'Very Low',
  },
  3: {
    description: 'Medium',
  },
  // 'high accuracy': { description: 'Location captured with high accuracy' },
  'low accuracy': { description: 'Low' },
  'ip': {
    description: 'Very Low',
  },
};

export function getDistanceUsingHaversine(
  latitude1: any,
  latitude2: any,
  longitude1: any,
  longitude2: any,
) {
  let lon1 = (longitude1 * Math.PI) / 180;
  let lon2 = (longitude2 * Math.PI) / 180;
  let lat1 = (latitude1 * Math.PI) / 180;
  let lat2 = (latitude2 * Math.PI) / 180;

  // Haversine formula
  let dlon = lon2 - lon1;
  let dlat = lat2 - lat1;
  let a =
    Math.pow(Math.sin(dlat / 2), 2) +
    Math.cos(lat1) * Math.cos(lat2) * Math.pow(Math.sin(dlon / 2), 2);

  let c = 2 * Math.asin(Math.sqrt(a));

  // Radius of earth in kilometers. Use 3956
  // for miles
  let r = 6371;

  // calculate the result

  return (c * r).toFixed(3);
}

export const cardDeleteActionIcon = [
  {
    condition: function (row: any) {
      return {
        icon: 'fs-5 fa-solid fa-circle-minus text-danger',
        title: 'Delete',
        confirm: true,
        type: 'delete',
      };
    },
  },
];

export function fetchUniqueQrText() {
  let userData = JSON.parse(localStorage.getItem('userData') || '{}');
  let subscriberCode =
    'CP-' +
    userData?.subscriber?.name
      ?.replace(/[\W_]+/gi, '')
      ?.slice(0, 4)
      ?.toUpperCase() +
    '-' +
    uuidv4();

  return subscriberCode;
}

export function getFormattedRepeatDetail(
  repeatType: string,
  repeatDetails: any,
) {
  let outputSring: any = '';
  if (repeatType === 'weekly') {
    outputSring = repeatDetails.join(', ');
  }
  if (repeatType === 'monthly') {
    if (repeatDetails?.every((item: any) => Number.isInteger(item))) {
      outputSring = repeatDetails.join(', ');
    } else {
      let value = '';
      let order = ['First', 'Second', 'Third', 'Fourth', 'Fifth']; // Add more if needed

      repeatDetails?.forEach(
        (item: any) =>
          (value += `${order[item.position - 1]} ${item.week_day}`),
      );
      outputSring = value;
    }
  }
  return outputSring;
}

export const invoiceDataDetail = {
  individualDetails: [
    {
      nestedValue: (row: any) => {
        return formatDate(row?.due_or_paid_date, 'd MMMM y', 'en_US');
      },
    },
    {
      name: 'invoice_reference',
      prefix: 'Invoice: ',
    },
    {
      nestedValue: (row: any) => {
        return `$${row?.amount_paid}`;
      },
    },
  ],
};

export function sortArrayOfObject(arr: any, key: any, sort_order = 'asc') {
  const order = sort_order.trim().toLowerCase();

  return arr.sort((a: any, b: any) => {
    let va = a[key];
    let vb = b[key];

    // If both undefined => equal
    if (va === undefined && vb === undefined) return 0;

    // Handle undefined cases
    if (va === undefined) {
      va = typeof vb === 'number' ? 0 : '';
    }
    if (vb === undefined) {
      vb = typeof va === 'number' ? 0 : '';
    }

    // Now compare normally
    if (va > vb) return order === 'asc' ? 1 : -1;
    if (va < vb) return order === 'asc' ? -1 : 1;
    return 0;
  });
}

export const subscriberStatus = {
  statusValues: {
    active: 'Active',
    inactive: 'Inactive',
    on_trial: 'On Trial',
    beta: 'Free Access',
    disabled: 'Disabled',
    closed: 'Closed',
    locked: 'Locked',
  },
  statusStyles: {
    active: {
      'background-color': 'var(--bs-success)',
      'color': 'var(--color-basic-100)',
      'display': 'flex',
      'padding': '4px',
      'justify-content': 'center',
      'font-weight': 'bold',
    },
    inactive: {
      'background-color': 'var(--bs-warning)',
      'color': 'var(--color-basic-100)',
      'display': 'flex',
      'padding': '4px',
      'justify-content': 'center',
      'font-weight': 'bold',
    },
    on_trial: {
      'background-color': 'var(--bs-info)',
      'color': 'var(--color-basic-100)',

      'display': 'flex',
      'padding': '4px',
      'justify-content': 'center',
      'font-weight': 'bold',
    },
    beta: {
      'background-color': 'var(--bs-secondary)',
      'color': 'var(--color-basic-100)',

      'display': 'flex',
      'padding': '4px',
      'justify-content': 'center',
      'font-weight': 'bold',
    },
    disabled: {
      'background-color': 'var(--bs-warning)',
      'color': 'var(--color-basic-100)',

      'display': 'flex',
      'padding': '4px',
      'justify-content': 'center',
      'font-weight': 'bold',
    },
    locked: {
      'background-color': 'var(--bs-primary)',
      'color': 'var(--color-basic-100)',

      'display': 'flex',
      'padding': '4px',
      'justify-content': 'center',
      'font-weight': 'bold',
    },
    closed: {
      'background-color': 'var(--bs-danger)',
      'color': 'var(--color-basic-100)',

      'display': 'flex',
      'padding': '4px',
      'justify-content': 'center',
      'font-weight': 'bold',
    },
  },
};
export function showGeoFenceAlert(
  minDistance: any,
  latitude1: any,
  latitude2: any,
  longitude1: any,
  longitude2: any,
) {
  try {
    const distanceInKm: any = getDistanceUsingHaversine(
      latitude1,
      latitude2,
      longitude1,
      longitude2,
    );

    return Boolean(distanceInKm * 1000 > minDistance);
  } catch (error) {
    return false;
  }
}

export function checkScanDistanceGreater(selectedEvent: any) {
  if (
    Boolean(
      selectedEvent?.checkpoint_details?.is_locked &&
      selectedEvent?.checkpoint_details?.qr_code &&
      selectedEvent?.checkpoint_details?.scan_detail &&
      selectedEvent?.checkpoint_details?.min_distance,
    )
  ) {
    const distanceInKm: any = getDistanceUsingHaversine(
      selectedEvent?.checkpoint_details?.scan_detail?.lat,
      selectedEvent?.gps?.lat,
      selectedEvent?.checkpoint_details?.scan_detail?.lon,
      selectedEvent?.gps?.lon,
    );
    if (distanceInKm * 1000 > selectedEvent?.checkpoint_details?.min_distance) {
      return {
        minDistance: selectedEvent?.checkpoint_details?.min_distance,
        scanDistance: distanceInKm * 1000,
      };
    }
  }
  return {};
}
export const globalPatrolRouteStatusDict = {
  1: {
    value: 'Complete',
    style: {
      'color': 'var(--bs-white)', // Bootstrap white text
      'background-color': 'var(--bs-dark)', // Bootstrap dark background
      'border-color': 'var(--bs-dark)', // Bootstrap dark border
      'border': '1px solid var(--bs-dark)',
      'border-radius': '5px',
      'padding': '0.5rem',
      'text-transform': 'uppercase',
      'margin-bottom': '0.5rem',
      'text-align': 'center',
      'font-weight': 700,
    },
  },
  2: {
    value: 'Completed with missed checkpoint scans',
    style: {
      'color': 'var(--bs-white)', // Bootstrap white text
      'background-color': 'var(--bs-dark)', // Bootstrap dark background
      'border-color': 'var(--bs-dark)', // Bootstrap dark border
      'border': '1px solid var(--bs-dark)',
      'border-radius': '5px',
      'padding': '0.5rem',
      'text-transform': 'uppercase',
      'margin-bottom': '0.5rem',
      'text-align': 'center',
      'font-weight': 700,
    },
  },
  3: {
    value: 'In Progress',
    style: {
      'color': 'var(--bs-white)', // Bootstrap white text
      'background-color': 'var(--bs-success)', // Bootstrap success background
      'border': '1px solid var(--bs-success)',
      'border-radius': '5px',
      'padding': '0.5rem',
      'text-transform': 'uppercase',
      'margin-bottom': '0.5rem',
      'text-align': 'center',
      'font-weight': 700,
    },
  },
  4: {
    value: 'Assigned Person Not Clocked In',
    style: {
      'color': 'var(--bs-white)', // Bootstrap white text
      'background-color': 'var(--bs-danger)', // Bootstrap danger background
      'border': '1px solid var(--bs-danger)',
      'border-radius': '5px',
      'padding': '0.5rem',
      'text-transform': 'uppercase',
      'margin-bottom': '0.5rem',
      'text-align': 'center',
      'font-weight': 700,
    },
  },
  5: {
    value: 'Has Not Started',
    style: {
      'color': 'var(--bs-white)', // Bootstrap white text
      'background-color': 'var(--bs-warning)', // Bootstrap warning background
      'border': '1px solid var(--bs-warning)',
      'border-radius': '5px',
      'padding': '0.5rem',
      'text-transform': 'uppercase',
      'margin-bottom': '0.5rem',
      'text-align': 'center',
      'font-weight': 700,
    },
  },
  6: {
    value: 'Has Not Started',
    style: {
      'color': 'var(--bs-white)', // Bootstrap white text
      'background-color': 'var(--bs-danger)', // Bootstrap danger background
      'border': '1px solid var(--bs-danger)',
      'border-radius': '5px',
      'padding': '0.5rem',
      'text-transform': 'uppercase',
      'margin-bottom': '0.5rem',
      'text-align': 'center',
      'font-weight': 700,
    },
  },
  7: {
    value: 'Unasigned Patrol',
    style: {
      'color': 'var(--bs-white)', // Bootstrap white text
      'background-color': 'var(--bs-danger)', // Bootstrap danger background
      'border': '1px solid var(--bs-danger)',
      'border-radius': '5px',
      'padding': '0.5rem',
      'text-transform': 'uppercase',
      'margin-bottom': '0.5rem',
      'text-align': 'center',
      'font-weight': 700,
    },
  },
};

export function getStartAndEndTime(startDateTime: Date) {
  let currentTime = new Date();

  if (currentTime.getTime() > startDateTime.getTime()) {
    startDateTime = new Date();
  }

  startDateTime = getNextQuarterHour(startDateTime);
  let endDateTime = new Date(startDateTime);
  endDateTime.setHours(
    startDateTime.getHours() + 8,
    startDateTime.getMinutes(),
  );
  return [startDateTime, endDateTime];
}

export function getNextQuarterHour(startDateTime: Date): Date {
  const targetDate = new Date(startDateTime);

  targetDate.setSeconds(0, 0);

  const minutes = targetDate.getMinutes();
  const nextQuarterHour = Math.ceil((minutes + 1) / 15) * 15;

  targetDate.setMinutes(nextQuarterHour);

  return targetDate;
}

export function getEventUpdateDetails(
  selectedEvent: any,
  selectedEventFrom: string,
) {
  let details: any = null;
  if (!selectedEvent?.history_changes?.length) return details;

  if (
    selectedEvent?.event_type === 'Patrol Update' ||
    selectedEvent?.event_type === 'Job Update' ||
    selectedEvent?.event_type === 'Incident Update' ||
    selectedEventFrom === 'patrol' ||
    selectedEventFrom === 'job' ||
    selectedEventFrom === 'runsheet'
  ) {
    details = {
      restore: null,
      delete: null,
      editedPatrol: null,
      editedJob: null,
      editedIncident: null,
      editedRunsheet: null,
    };
    const sortedHistory = selectedEvent?.history_changes.sort(
      (a: any, b: any) =>
        new Date(a?.updated_at).getTime() - new Date(b?.updated_at).getTime(),
    );

    sortedHistory.forEach((item: any) => {
      if (
        selectedEvent?.event_type === 'Runsheet Update' ||
        selectedEventFrom === 'runsheet'
      ) {
        switch (item.event_action) {
          case 15:
            details.restore = item;
            break;

          case 14:
            details.delete = item;
            break;

          case 16:
            details.editedRunsheet = item;

            break;
        }
      }
      if (
        selectedEvent?.event_type === 'Patrol Update' ||
        selectedEventFrom === 'patrol'
      ) {
        switch (item.event_action) {
          case 11:
            details.restore = item;
            break;

          case 10:
            details.delete = item;
            break;

          case 5:
            details.editedPatrol = item;
            break;
        }
      }
      if (
        selectedEvent?.event_type === 'Job Update' ||
        selectedEventFrom === 'job'
      ) {
        switch (item?.event_action) {
          case 9:
            details.editedJob = item;
            break;

          case 24:
            details.delete = item;
            break;

          case 25:
            details.restore = item;
            break;
        }
      }
      if (selectedEvent?.event_type === 'Incident Update') {
        switch (item?.event_action) {
          case 3:
            details.editedIncident = item;

            break;
        }
      }
    });
  }

  return details;
}

export async function compressImage(
  file: File,
  maxTime: number = 30000,
  maxSizeAllowed: number = 1500,
): Promise<Blob | null> {
  const spinnerService = new LoadingSpinnerService();
  const controller = new AbortController();
  const signal = controller.signal;
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      controller.abort();
      reject(
        new Error(
          'There was a problem loading the photo. The photo may have been too large and took too long to compress.',
        ),
      );
    }, maxTime);

    const img = document.createElement('img');
    img.src = URL.createObjectURL(file);

    // Wait for the image to load
    img.onload = async () => {
      spinnerService.show('Preparing');
      if (signal.aborted) return;
      try {
        const MAX_SIZE = maxSizeAllowed; // Set your desired max size

        if (img.width <= MAX_SIZE && img.height <= MAX_SIZE) {
          // If dimensions are less than or equal to MAX_SIZE, return the file as AVIF
          const canvas = document.createElement('canvas');
          const ctx: any = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;
          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
          spinnerService.show('Compressing');
          const avifBlob: any = await new Promise((resolve) => {
            canvas.toBlob(
              (blob) => {
                resolve(blob);
              },
              'image/avif',
              1,
            );
          });

          clearTimeout(timeout); // Clear the timeout if done
          resolve(new File([avifBlob], file.name, { type: 'image/avif' }));
          return; // Stop further execution
        }

        const canvas = document.createElement('canvas');
        const ctx: any = canvas.getContext('2d');

        let scaleSize = 1;

        if (img.width > img.height && img.width > MAX_SIZE) {
          scaleSize = MAX_SIZE / img.width;
        } else if (img.height > img.width && img.height > MAX_SIZE) {
          scaleSize = MAX_SIZE / img.height;
        } else if (img.width === img.height && img.width > MAX_SIZE) {
          scaleSize = MAX_SIZE / img.width;
        }

        canvas.width = img.width * scaleSize;
        canvas.height = img.height * scaleSize;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
        spinnerService.show('Compressing');
        let finalType = 'image/avif';
        let compressedBlob: any = await new Promise((resolve) => {
          canvas.toBlob(
            (blob) => {
              resolve(blob);
            },
            finalType,
            0.8,
          );
        });
        if (!compressedBlob || compressedBlob.type !== finalType) {
          // case for browsers in mac os where image compression to avif is not working
          finalType = 'image/jpeg';
          compressedBlob = await new Promise((res) => {
            canvas.toBlob((b) => res(b), finalType, 0.8);
          });
        }

        if (!compressedBlob) {
          throw new Error('Image compression failed to produce a valid file.');
        }

        clearTimeout(timeout); // Clear the timeout if done
        resolve(new File([compressedBlob], file.name, { type: finalType }));
      } catch (error) {
        clearTimeout(timeout); // Ensure timeout is cleared on error
        reject(error); // Reject the promise with the error
      }
    };

    img.onerror = (error) => {
      clearTimeout(timeout); // Ensure timeout is cleared on error
      reject(error);
    };
  });
}
export async function compressImageAndAddData(
  file: File,
  maxTime: number = 30000,
  maxSizeAllowed: number = 1500,
  addData: any = {},
): Promise<Blob | null> {
  const spinnerService = new LoadingSpinnerService();
  const controller = new AbortController();
  const signal = controller.signal;
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      controller.abort();
      reject(
        new Error(
          'There was a problem loading the photo. The photo may have been too large and took too long to compress.',
        ),
      );
    }, maxTime);

    const img = document.createElement('img');
    img.src = URL.createObjectURL(file);

    // Wait for the image to load
    img.onload = async () => {
      spinnerService.show('Preparing');
      if (signal.aborted) return;
      try {
        const MAX_SIZE = maxSizeAllowed; // Set your desired max size

        if (img.width <= MAX_SIZE && img.height <= MAX_SIZE) {
          // If dimensions are less than or equal to MAX_SIZE, return the file as AVIF
          let canvas = document.createElement('canvas');
          let ctx: any = canvas.getContext('2d');
          canvas.width = img.width;
          canvas.height = img.height;

          ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

          if (addData?.updated_at) {
            spinnerService.show('Timestamping image');
            addInfoToImage(addData, ctx, canvas);
          }

          spinnerService.show('Compressing');
          let finalType = 'image/avif';
          let compressedBlob: any = await new Promise((resolve) => {
            canvas.toBlob(
              (blob) => {
                resolve(blob);
              },
              finalType,
              0.8,
            );
          });
          if (!compressedBlob || compressedBlob.type !== finalType) {
            // case for browsers in mac os where image compression to avif is not working
            finalType = 'image/jpeg';
            compressedBlob = await new Promise((res) => {
              canvas.toBlob((b) => res(b), finalType, 0.8);
            });
          }

          if (!compressedBlob) {
            throw new Error(
              'Image compression failed to produce a valid file.',
            );
          }

          clearTimeout(timeout); // Clear the timeout if done
          resolve(new File([compressedBlob], file.name, { type: finalType }));
          return; // Stop further execution
        }

        let canvas = document.createElement('canvas');
        let ctx: any = canvas.getContext('2d');

        let scaleSize = 1;

        if (img.width > img.height && img.width > MAX_SIZE) {
          scaleSize = MAX_SIZE / img.width;
        } else if (img.height > img.width && img.height > MAX_SIZE) {
          scaleSize = MAX_SIZE / img.height;
        } else if (img.width === img.height && img.width > MAX_SIZE) {
          scaleSize = MAX_SIZE / img.width;
        }

        canvas.width = img.width * scaleSize;
        canvas.height = img.height * scaleSize;
        ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

        if (addData?.updated_at) {
          spinnerService.show('Timestamping image');
          addInfoToImage(addData, ctx, canvas);
        }

        spinnerService.show('Compressing');
        const compressedBlob: any = await new Promise((resolve) => {
          canvas.toBlob(
            (blob) => {
              resolve(blob);
            },
            'image/avif',
            0.8,
          );
        });

        clearTimeout(timeout); // Clear the timeout if done
        resolve(new File([compressedBlob], file.name, { type: 'image/avif' }));
      } catch (error) {
        clearTimeout(timeout); // Ensure timeout is cleared on error
        reject(error); // Reject the promise with the error
      }
    };

    img.onerror = (error) => {
      clearTimeout(timeout); // Ensure timeout is cleared on error
      reject(error);
    };
  });
}

function addInfoToImage(addData: any, ctx: any, canvas: any) {
  const padding = 20;
  let fontSize = 58;
  ctx.textAlign = 'right';
  ctx.textBaseline = 'top';
  ctx.lineWidth = 8;

  // Format text content
  const timestamp = formatDate(
    addData?.updated_at,
    'dd MMMM yyyy h:mm:ss aa',
    'en_US',
  );
  const addressLine1 = `${addData?.address1 ?? ''} ${addData?.address2 ?? ''}`;
  const addressLine2 = `${addData?.city_name ?? ''}, ${
    addData?.state_code ?? addData?.state_code ?? ''
  }, ${addData?.postcode ?? ''}`;
  const addressLine3 = `${addData?.country_name ?? ''}`;

  ctx.font = `${fontSize}px 'Poppins', Arial, sans-serif`;
  let maxTextWidth = Math.max(
    ctx.measureText(timestamp).width,
    ctx.measureText(addressLine1).width,
    ctx.measureText(addressLine2).width,
    ctx.measureText(addressLine3).width,
  );

  while (maxTextWidth + padding * 2 > canvas.width && fontSize > 10) {
    fontSize -= 2;
    ctx.font = `${fontSize}px 'Poppins', Arial, sans-serif`;
    maxTextWidth = Math.max(
      ctx.measureText(timestamp).width,
      ctx.measureText(addressLine1).width,
      ctx.measureText(addressLine2).width,
      ctx.measureText(addressLine3).width,
    );
  }

  const lineHeight = fontSize * 1.5;
  const lines = [
    { text: timestamp, yPos: padding },
    { text: addressLine1, yPos: padding + lineHeight },
    { text: addressLine2, yPos: padding + lineHeight * 2 },
    { text: addressLine3, yPos: padding + lineHeight * 3 },
  ];

  // Loop through lines and render only non-empty ones
  let currentYPos = padding;
  ctx.fillStyle = 'white';
  ctx.strokeStyle = 'black';
  ctx.lineWidth = 6;
  ctx.textAlign = 'right';
  ctx.textBaseline = 'top';

  lines.forEach((line) => {
    const lineText = line?.text?.trim();
    if (lineText) {
      // Check if the line has text
      ctx.strokeText(lineText, canvas.width - padding, currentYPos);
      ctx.fillText(lineText, canvas.width - padding, currentYPos);
      currentYPos += lineHeight;
    }
  });
}
export function areObjectsEqual(obj1: any, obj2: any): boolean {
  if (obj1 === null || obj2 === null) {
    return obj1 === obj2;
  }

  if (typeof obj1 !== 'object' || typeof obj2 !== 'object') {
    return obj1 === obj2;
  }
  const keys1 = Object.keys(obj1);
  const keys2 = Object.keys(obj2);

  if (keys1?.length !== keys2?.length) {
    return false;
  }

  for (const key of keys1) {
    if (typeof obj1[key] === 'object' && typeof obj2[key] === 'object') {
      if (!areObjectsEqual(obj1[key], obj2[key])) {
        return false;
      }
    } else {
      if (obj1[key] !== obj2[key]) {
        return false;
      }
    }
  }

  return true;
}
export function getRosterDateAfterJobAdd(startDay?: any) {
  if (!startDay) return getFormattedDate();
  const diff = new Date(startDay).getTime() - new Date().getTime();

  if (diff > 1000 * 60 * 60 * 24 * 7)
    return getFormattedDate(new Date(startDay));

  return getFormattedDate();
}
export function getMultiSelectSearchValue(column: any) {
  let searchValue: any;
  const searchValues = column
    ?.dropDownList()
    ?.filter((item: any) => column?.selectedItems?.includes(item?.id));

  if (searchValues?.length) {
    searchValue = searchValues?.map((item: any) => item?.name)?.join(', ');
  }
  return searchValue;
}

export function updateCustomTableHeaders(tableHeaders: any, searchParams: any) {
  tableHeaders?.forEach((element: any) => {
    const filterKey = element?.searchKey || element?.name;
    if (element?.datetimeObj) {
      const rangeArray = searchParams?.[`${filterKey}__range`] || [];
      if (rangeArray?.length) {
        element.searchValue = { start: rangeArray[0], end: rangeArray[1] };
      }
    } else if (element?.dropdownKey) {
      if (element?.multipleSelect) {
        element.selectedItems = searchParams?.[`${element.dropdownKey}__in`];
        element.searchValue = getMultiSelectSearchValue(element);
      } else {
        element.searchValue = searchParams?.[element?.dropdownKey];
      }
    } else {
      element.searchValue = searchParams?.[`${filterKey}__icontains`];
    }
  });
}
export function areArrayItemsSame(a: any, b: any): boolean {
  if (a?.length !== b?.length) return false;
  const setA = new Set(a);
  const setB = new Set(b);
  if (setA.size !== setB.size) return false;
  for (const id of setA) {
    if (!setB.has(id)) return false;
  }
  return true;
}

export function getPromptFileIdsForUrls(prompts: any, existingPromptIds: any) {
  function getFileIdsFromNestedData(
    innerItem: any,
    newPromptFileIds: any = [],
  ) {
    if (innerItem?.options && innerItem?.options?.length) {
      innerItem?.options?.forEach((item: any) => {
        if (item?.file_id) {
          newPromptFileIds.add(item?.file_id);
        }
        getFileIdsFromNestedData(item, newPromptFileIds);
      });
    }
  }
  const newPromptFileIdsSet = new Set<any>();
  prompts?.forEach((outerItem: any) => {
    outerItem?.data?.forEach((innerItem: any) => {
      if (innerItem?.file_id) {
        newPromptFileIdsSet.add(innerItem?.file_id);
      }
      getFileIdsFromNestedData(innerItem, newPromptFileIdsSet);
    });
  });

  const newPromptFileIds = [...newPromptFileIdsSet];

  return areArrayItemsSame(existingPromptIds, newPromptFileIds)
    ? false
    : newPromptFileIds;
}
export function haveSameIds(
  a: any,
  aKey: string,
  b: any,
  bKey: string,
): boolean {
  if (a?.length !== b?.length) return false;

  const idsA = new Set(a?.map((item: any) => item?.[aKey]));
  const idsB = new Set(b?.map((item: any) => item?.[bKey]));

  if (idsA?.size !== idsB?.size) return false;

  return [...idsA]?.every((id) => idsB?.has(id));
}
export function getScheduleCellKey(
  uniqueId: string | number,
  date: Date,
): string {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);

  return `${uniqueId}_${d.getTime()}`;
}
export async function uploadedFileCheck(
  fileExtension: string,
  fileSize: number,
  fileLimit: number = 1024 * 1024 * 2,
  allowedExtensions = allowedImageFormats,
): Promise<string> {
  if (!allowedExtensions.includes(fileExtension?.toLowerCase())) {
    return 'Unsupported file format';
  } else if (fileSize > fileLimit) {
    return 'File Too Large ' + fileSize + ' / ' + fileLimit;
  } else {
    return '';
  }
}
export const NativeUploadUpdateStatus = {
  PENDING: 1,
  IN_PROGRESS: 2,
  DONE: 3,
  FAILED: 4, // permanent failure (e.g. server rejected it), needs attention
} as const;
